define('util/imgpreload',[
    'jquery',
    'underscore'
],function($, _){
    
    /**
     * load given $images
     * 
     * @provide Deferred
     * @param {type} oImg
     * @returns {unresolved}
     */
    
    return function(oImg)
    {
        var $deferred=new $.Deferred(),
                iImg=oImg.length,
                iDone=0,
                resolve=function()
                {
                    iDone++;
                    if(iDone>=iImg) {
                        $deferred.resolve();
                    }
                };
        
        _.each(oImg,function(el){
            var oImg=new Image();
            
            oImg.src=el.src;
            oImg.onload=resolve;
            oImg.onerror=resolve;
        });
        if(iImg === 0){
            $deferred.resolve();
        }

        return $deferred.promise();
    };
});
